'use client';
import { createContext, useContext, useState, ReactNode } from 'react';

type OrgInterDadosGeraisContextType = {
  componente: number;
  orgInter: number;
  userID: number;
  setComponente: (value: number) => void;
  setOrgInter: (value: number) => void;
  setUserID: (value: number) => void;
};

const OrgInterDadosGeraisContext = createContext<
  OrgInterDadosGeraisContextType | undefined
>(undefined);

export function OrgInterDadosGeraisProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [componente, setComponente] = useState<number>(0);
  const [orgInter, setOrgInter] = useState<number>(0);
  const [userID, setUserID] = useState<number>(0);

  return (
    <OrgInterDadosGeraisContext.Provider
      value={{
        componente,
        orgInter,
        userID,
        setComponente,
        setOrgInter,
        setUserID,
      }}
    >
      {children}
    </OrgInterDadosGeraisContext.Provider>
  );
}

export function useOrgInterDadosGerais() {
  const context = useContext(OrgInterDadosGeraisContext);
  if (!context) {
    throw new Error('useOrgInter deve ser usado dentro de um OrgInterProvider');
  }
  return context;
}
